import { Glyph } from "@motleyhand/design"
import Hero from "./Hero"
import Pain from "./Pain"
import Staircase from "./staircase/Staircase"
import Craftsmanship from "./Craftsmanship"
import Terms from "./Terms"
import Cta from "./Cta"
import DemoVideo from "@/content/homepage/DemoVideo"

export default function Homepage() {
  return (
    <>
      <Hero />
      <div className="flex justify-center">
        <Glyph variant="divider-spread" />
      </div>
      <Pain />
      <DemoVideo />
      <Staircase />
      <Craftsmanship />
      <Terms />
      <Cta />
    </>
  )
}
